let navLinks = document.querySelectorAll(
  ".hp-widget-tab-desktop .nav-tabs .nav-link"
);
let menuSeparator = document.querySelector(
  ".hp-widget-tab-desktop .menu-separator"
);

navLinks.forEach((item) => {
  item.addEventListener("click", () => {
    menuSeparator.style.display = "none";
    navLinks.forEach((item) => {
      item.parentElement.classList.remove("active-link");
    });
    item.parentElement.classList.add("active-link");
  });
});

let closeBtns = document.querySelectorAll(
  ".hp-widget-tab-desktop .tab-content .tab-pane .close-btn"
);
closeBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.closest(".tab-pane").classList.remove("active");
    navLinks.forEach((item) => {
      item.classList.remove("active");
      item.parentElement.classList.remove("active-link");
    });
    menuSeparator.style.display = "block";
  });
});
